import { useCallback } from 'react';
import UISortTH from 'UIComponents/table/UISortTH';
import { SortValues } from '../constants/SortValues';
import { jsx as _jsx } from "react/jsx-runtime";
export default function SortTH({
  children,
  columnKey,
  sort,
  onSortChange,
  align,
  style,
  truncate
}) {
  const handleSortChange = useCallback(event => {
    var _event$target;
    return onSortChange({
      columnKey,
      sortValue: (_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.value
    });
  }, [columnKey, onSortChange]);
  return /*#__PURE__*/_jsx(UISortTH, {
    align: align,
    "data-test-id": `sort-column-${columnKey}`,
    onSortChange: handleSortChange,
    sort: columnKey === sort.columnKey ? sort.sortValue : SortValues.NONE,
    style: style,
    truncate: truncate,
    children: children
  });
}